// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-administrator-customers-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-administrator-customers-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-administrator-customers-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-administrator-customers-container{
        width: 90%;
        height: 85%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
    }
    .customer-administrator-customers-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-administrator-customers-header-container h2{
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .customer-administrator-customers-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-administrator-refresh-customers-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 5px 7px;
    }
    .customer-administrator-refresh-customers-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-administrator-refresh-customers-button img{
        height: 25px;
    }
    .customer-administrator-customers-table-container{
        overflow: auto;
        max-height: 71.5vh;
        box-sizing: border-box;
    }
    .customer-administrator-customers-table-container::-webkit-scrollbar{
        width: 4px;
    }
    .customer-administrator-customers-table-container::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .customer-administrator-customers-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .customer-administrator-customers-table th, .customer-administrator-customers-table td{
        text-align: left;
        padding: 10px 5px;
        white-space: nowrap;
    }
    .customer-administrator-customers-table td{
        font-size: 12px;
    }
    #customer-administrator-customers-table-header-row{
        color: black;
        background-color: transparent;
    }
    .customer-administrator-customers-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-administrator-customers-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}
@media screen and (max-width:949px){
    .customer-administrator-customers-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-administrator-customers-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-administrator-customers-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-administrator-customers-container{
        height: 88vh;
        width: 100vw;
        border-radius: 2px;
        box-shadow: none;
    }
    .customer-administrator-customers-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-administrator-customers-header-container h2{
        font-weight: lighter;
        font-size: 16px;
        padding-left: 15px;
        color: rgb(90, 90, 90);
    }
    .customer-administrator-customers-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-administrator-refresh-customers-button{
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 4px 7px;
        padding-top: 6px;
        margin-top: 4px;
        margin-right: 10px;
        background-color: transparent;
    }
    .customer-administrator-refresh-customers-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-administrator-refresh-customers-button img{
        height: 20px;
    }
    .customer-administrator-customers-table-container{
        overflow: auto;
        max-height: 71.5vh;
    }
    .customer-administrator-customers-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .customer-administrator-customers-table th, .customer-administrator-customers-table td{
        text-align: left;
        padding: 10px 5px;
        white-space: nowrap;
        display: none;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-administrator-customers-table th:nth-child(1),.customer-administrator-customers-table td:nth-child(1){
        padding-left: 15px;
        max-width: 28vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .customer-administrator-customers-table td:nth-child(5) div{
        max-width: 28vw;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: ellipsis;
    }
    .customer-administrator-customers-table td:last-child div{
        max-width: 20vw;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: ellipsis;
    }
    .customer-administrator-customers-table th:nth-child(1),.customer-administrator-customers-table th:nth-child(5),.customer-administrator-customers-table th:nth-child(6),
    .customer-administrator-customers-table td:nth-child(1),.customer-administrator-customers-table td:nth-child(5),.customer-administrator-customers-table td:nth-child(6){
        display: table-cell;
    }
    .customer-administrator-customers-table th{
        font-size: 14px;
        font-weight: 500;
    }
    .customer-administrator-customers-table td{
        font-size: 12px;
    }
    #customer-administrator-customers-table-header-row{
        color: black;
        background-color: transparent;
    }
    .customer-administrator-customers-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-administrator-customers-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/Customers/Customers.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,sCAAsC;QACtC,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,6BAA6B;IACjC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,4DAA4D;IAChE;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;;QAEI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-administrator-customers-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-administrator-customers-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-administrator-customers-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-administrator-customers-container{\r\n        width: 90%;\r\n        height: 85%;\r\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n        padding: 2% 3%;\r\n        border-radius: 5px;\r\n        position: relative;\r\n    }\r\n    .customer-administrator-customers-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-customers-header-container h2{\r\n        font-weight: lighter;\r\n        color: rgb(90, 90, 90);\r\n    }\r\n    .customer-administrator-customers-header-controls{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-refresh-customers-button{\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 5px 7px;\r\n    }\r\n    .customer-administrator-refresh-customers-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-administrator-refresh-customers-button img{\r\n        height: 25px;\r\n    }\r\n    .customer-administrator-customers-table-container{\r\n        overflow: auto;\r\n        max-height: 71.5vh;\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-administrator-customers-table-container::-webkit-scrollbar{\r\n        width: 4px;\r\n    }\r\n    .customer-administrator-customers-table-container::-webkit-scrollbar-thumb{\r\n        border-radius: 5px;\r\n        background-color: rgba(0, 0, 0, 0.3);\r\n    }\r\n    .customer-administrator-customers-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .customer-administrator-customers-table th, .customer-administrator-customers-table td{\r\n        text-align: left;\r\n        padding: 10px 5px;\r\n        white-space: nowrap;\r\n    }\r\n    .customer-administrator-customers-table td{\r\n        font-size: 12px;\r\n    }\r\n    #customer-administrator-customers-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    .customer-administrator-customers-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-administrator-customers-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-administrator-customers-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    }\r\n    .customer-administrator-customers-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-administrator-customers-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-administrator-customers-container{\r\n        height: 88vh;\r\n        width: 100vw;\r\n        border-radius: 2px;\r\n        box-shadow: none;\r\n    }\r\n    .customer-administrator-customers-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-customers-header-container h2{\r\n        font-weight: lighter;\r\n        font-size: 16px;\r\n        padding-left: 15px;\r\n        color: rgb(90, 90, 90);\r\n    }\r\n    .customer-administrator-customers-header-controls{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-refresh-customers-button{\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 4px 7px;\r\n        padding-top: 6px;\r\n        margin-top: 4px;\r\n        margin-right: 10px;\r\n        background-color: transparent;\r\n    }\r\n    .customer-administrator-refresh-customers-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-administrator-refresh-customers-button img{\r\n        height: 20px;\r\n    }\r\n    .customer-administrator-customers-table-container{\r\n        overflow: auto;\r\n        max-height: 71.5vh;\r\n    }\r\n    .customer-administrator-customers-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .customer-administrator-customers-table th, .customer-administrator-customers-table td{\r\n        text-align: left;\r\n        padding: 10px 5px;\r\n        white-space: nowrap;\r\n        display: none;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-administrator-customers-table th:nth-child(1),.customer-administrator-customers-table td:nth-child(1){\r\n        padding-left: 15px;\r\n        max-width: 28vw;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .customer-administrator-customers-table td:nth-child(5) div{\r\n        max-width: 28vw;\r\n        margin-right: 10px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        box-sizing: border-box;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .customer-administrator-customers-table td:last-child div{\r\n        max-width: 20vw;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        box-sizing: border-box;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .customer-administrator-customers-table th:nth-child(1),.customer-administrator-customers-table th:nth-child(5),.customer-administrator-customers-table th:nth-child(6),\r\n    .customer-administrator-customers-table td:nth-child(1),.customer-administrator-customers-table td:nth-child(5),.customer-administrator-customers-table td:nth-child(6){\r\n        display: table-cell;\r\n    }\r\n    .customer-administrator-customers-table th{\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n    }\r\n    .customer-administrator-customers-table td{\r\n        font-size: 12px;\r\n    }\r\n    #customer-administrator-customers-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    .customer-administrator-customers-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-administrator-customers-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
